import { createRouter, createWebHistory } from 'vue-router'
import AdminLayout from '../layouts/AdminLayout.vue'
import ClientLayout from '../layouts/ClientLayout.vue'
import { useLangStore } from '../stores/lang'
import { useAuthStore } from '../stores/auth'
import { ElMessage } from 'element-plus'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/admin/users'
      },
      {
        path: 'users',
        name: 'UserManagement',
        meta: { title: '用户管理' },
        component: () => import('../views/admin/UserManagement.vue')
      },
      {
        path: 'news-categories',
        name: 'NewsCategoryManagement',
        meta: { title: '新闻分类管理' },
        component: () => import('../views/admin/NewsCategoryManagement.vue')
      },
      {
        path: 'news',
        name: 'NewsManagement',
        meta: { title: '新闻管理' },
        component: () => import('../views/admin/NewsManagement.vue')
      },
      {
        path: 'news/create',
        name: 'NewsCreate',
        meta: { title: '新闻创建' },
        component: () => import('../views/admin/NewsForm.vue')
      },
      {
        path: 'news/edit/:id',
        name: 'NewsEdit',
        meta: { title: '新闻编辑' },
        component: () => import('../views/admin/NewsForm.vue')
      },
      {
        path: '/admin/menus',
        name: 'MenuManagement',
        meta: { title: '菜单管理' },
        component: () => import('@/views/admin/MenuList.vue'),
      },
      {
        path: 'works',
        name: 'WorkManagement',
        meta: { title: '作品管理' },
        component: () => import('@/views/admin/WorkList.vue')
      },
      {
        path: 'forms',
        name: 'FormManagement',
        meta: { title: '表单管理' },
        component: () => import('@/views/admin/FormList.vue')
      },
      {
        path: 'forms/create',
        name: 'FormCreate',
        meta: { title: '表单创建' },
        component: () => import('@/views/admin/FormEdit.vue')
      },
      {
        path: 'forms/edit/:id',
        name: 'FormEdit',
        meta: { title: '表单编辑' },
        component: () => import('@/views/admin/FormEdit.vue')
      },
      {
        path: 'forms/:id/submit',
        name: 'FormSubmit',
        meta: { title: '表单提交' },
        component: () => import('@/views/admin/FormSubmit.vue')
      },
      {
        path: 'forms/:id/submissions',
        name: 'FormSubmissions',
        meta: { title: '提交记录' },
        component: () => import('@/views/admin/FormSubmissions.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'Home',
    component: ClientLayout,
    children: [
      {
        path: '',
        redirect: '/home'
      },
      // {
      //   path: 'profile',
      //   meta: { title: '个人中心' },
      //   component: () => import('../views/client/ProfilePage.vue')
      // },
      {
        path: 'home',
        meta: { title: '宣传视频' },
        component: () => import('../views/client/HomePage.vue')
      },
      {
        path: 'rules',
        meta: { title: '大赛规则' },
        component: () => import('../views/client/RulesPage.vue')
      },
      {
        path: 'judging',
        meta: { title: '评审规则' },
        component: () => import('../views/client/JudgingPage.vue')
      },
      {
        path: 'prize',
        meta: { title: '奖金设置' },
        component: () => import('../views/client/PrizePage.vue')
      },
      {
        path: 'news',
        meta: { title: '相关新闻' },
        component: () => import('../views/client/NewsPage.vue')
      },
      {
        path: 'news/:id',
        name: 'NewsDetail',
        meta: { title: '新闻详情' },
        component: () => import('../views/client/NewsDetail.vue')
      },
      {
        path: 'works',
        meta: { title: '作品投票' },
        component: () => import('../views/client/WorksPage.vue')
      },
      {
        path: 'works/:id',
        name: 'WorksDetail',
        meta: { title: '作品详情' },
        component: () => import('../views/client/WorksDetail.vue')
      }
    ]
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: { requiresAuth: false, title: '404 Not Found' }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  const token = authStore.token
  const userInfo = authStore.user

  // 检查是否需要认证
  if (to.meta.requiresAuth && !token) {
    ElMessage.warning('请先登录')
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
    return
  }

  // 检查管理后台访问权限
  if (to.path.startsWith('/admin')) {
    if (!token) {
      ElMessage.warning('请先登录')
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    }
    
    if (!userInfo?.is_superuser) {
      ElMessage.error('您没有访问管理后台的权限')
      next('/')
      return
    }
  }

  // 如果是访问登录页面且已登录，重定向到首页
  if (to.path === '/login' && token) {
    next('/')
    return
  }

  // 设置页面标题
  document.title = to.meta.title || process.env.VUE_APP_TITLE
  next()
})

export default router 